export interface MissionDefinition {
  id: string;
  title: string;
  icon: string;
  hint: string;
  rewardCoins: number;
  rewardStars: number;
  route: readonly { x: number; z: number }[];
}

/** Kleine, komplett spielbare Missionsrunde fuer die kompakte Insel. */
export const MISSIONS: readonly MissionDefinition[] = [
  {
    id: 'lieferfahrt',
    title: 'LIEFERFAHRT',
    icon: '📦',
    hint: 'FAHRE DURCH DIE LEUCHTENDEN RINGE',
    rewardCoins: 30,
    rewardStars: 1,
    route: [
      { x: 0, z: 58 },
      { x: 0, z: -112 },
      { x: 96, z: -132 },
      { x: 118, z: -62 },
    ],
  },
  {
    id: 'stadtrunde',
    title: 'STADTRUNDE',
    icon: '🏙️',
    hint: 'FOLGE DEN STRASSEN DURCH DIE STADT',
    rewardCoins: 45,
    rewardStars: 2,
    route: [
      { x: -118, z: 88 },
      { x: -118, z: -112 },
      { x: 0, z: -132 },
      { x: 118, z: -92 },
      { x: 118, z: 112 },
      { x: 0, z: 126 },
    ],
  },
  {
    id: 'landpartie',
    title: 'LANDPARTIE',
    icon: '🌳',
    hint: 'FAHRE DIE GROSSE RUNDE AM STADTRAND',
    rewardCoins: 55,
    rewardStars: 3,
    route: [
      { x: 0, z: 218 },
      { x: 0, z: 126 },
      { x: -118, z: 126 },
      { x: -118, z: -132 },
      { x: 0, z: -220 },
    ],
  },
];

export const COLLECTIBLES = [
  { id: 'werkzeug-01', x: 8, z: 25 },
  { id: 'werkzeug-02', x: -8, z: -72 },
  { id: 'werkzeug-03', x: 82, z: -124 },
  { id: 'werkzeug-04', x: -108, z: -54 },
  { id: 'werkzeug-05', x: 106, z: 80 },
  { id: 'werkzeug-06', x: -82, z: 118 },
  { id: 'werkzeug-07', x: 8, z: 188 },
  { id: 'werkzeug-08', x: -8, z: -205 },
] as const;
